export default {"src":"/_next/static/image/public/images/ic_no_map_found.820febec89c2d12fe3344e191ae537d7.svg","height":138,"width":153};